import { PlatformSidebarItem } from "@aurem/components";
import { cn, Popover, useBreakpoints } from "@aurem/ui";
import { LayoutGridIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ControlsContent } from "./ControlsContent";

export const ControlsDropdown = () => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoints();

  const maxWidth = useMemo(() => {
    if (!isMobile) return 750;
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return window.innerWidth - 8.25 * rem;
  }, [isMobile]);

  const isActive = pathname.includes("controls");
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      content={<ControlsContent onClose={handleClose} />}
      placement="right-end"
      contentClassName="p-0"
      maxWidth={maxWidth}
      offset={{
        mainAxis: isMobile ? 36 : 17,
        crossAxis: 0,
      }}
    >
      <div
        className={cn(
          "flex flex-col w-full items-center gap-1 rounded-md cursor-pointer",
          "focus-visible:outline focus-visible:outline-white focus-visible:outline-offset-[2px]",
        )}
      >
        <PlatformSidebarItem
          icon={<LayoutGridIcon size={20} />}
          label={t("apps.admin.navBar.controls")}
          isActive={isActive}
        />
      </div>
    </Popover>
  );
};
